module.exports = __webpack_public_path__ + "img/915-bdd47d.png";